import React from "react";
import { useTranslation } from "react-i18next";

/**
 * Explainer copy for the Create Event info modals, ported verbatim (promoter
 * variant only, since this panel is promoter-only) from the mobile app's
 * translation strings in src/translation/en/index.js — see onShare,
 * onQRInfo, onChatAccessLevels, onOpenDoorPhaseAccessToast in
 * create-event-update/index.js for the source call sites.
 */

const Heading = ({ children }) => (
  <p style={{ fontWeight: 700, color: "#1e1e2d", margin: "0 0 4px" }}>{children}</p>
);

export const ShareInfoContent = () => {
  const { t } = useTranslation("events");
  return (
    <>
      <Heading>{t("shareInfoContent.heading1")}</Heading>
      <p>{t("shareInfoContent.body1a")}</p>
      <p style={{ marginBottom: 16 }}>{t("shareInfoContent.body1b")}</p>
      <Heading>{t("shareInfoContent.heading2")}</Heading>
      <p>{t("shareInfoContent.intro2")}</p>
      <p>{t("shareInfoContent.body2a")}</p>
      <p>{t("shareInfoContent.body2b")}</p>
    </>
  );
};

export const QRInfoContent = () => {
  const { t } = useTranslation("events");
  return (
    <>
      <Heading>{t("qrInfoContent.heading1")}</Heading>
      <p>{t("qrInfoContent.point1")}</p>
      <p>{t("qrInfoContent.point2")}</p>
      <p>{t("qrInfoContent.point3")}</p>
      <p style={{ marginBottom: 16 }}>{t("qrInfoContent.point4")}</p>
      <Heading>{t("qrInfoContent.heading2")}</Heading>
      <p>{t("qrInfoContent.point5")}</p>
      <p>{t("qrInfoContent.point6")}</p>
      <p>{t("qrInfoContent.point7")}</p>
      <p>{t("qrInfoContent.point8")}</p>
    </>
  );
};

export const ChatAccessInfoContent = () => {
  const { t } = useTranslation("events");
  return (
    <>
      <Heading>{t("chatAccessInfoContent.heading1")}</Heading>
      <p>{t("chatAccessInfoContent.body1a")}</p>
      <p style={{ marginBottom: 16 }}>{t("chatAccessInfoContent.body1b")}</p>
      <Heading>{t("chatAccessInfoContent.heading2")}</Heading>
      <p>{t("chatAccessInfoContent.body2a")}</p>
      <p>{t("chatAccessInfoContent.body2b")}</p>
      <p>{t("chatAccessInfoContent.body2c")}</p>
    </>
  );
};

export const OpenDoorPhaseInfoContent = () => {
  const { t } = useTranslation("events");
  return <p>{t("openDoorPhaseInfoContent.body")}</p>;
};
